import { Options, parse } from 'csv-parse/browser/esm';

export function parseCsv<T>(input: string, options?: Options): Promise<T> {
  return new Promise((resolve, reject) => {
    parse(
      input,
      {
        columns: true,
        trim: true,
        // eslint-disable-next-line camelcase
        relax_column_count_less: true,
        ...options,
      },
      (err, records: unknown) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(records as T);
      }
    );
  });
}
